import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { FcmNotification } from "./../../../models/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { InvoiceComponent } from "../invoice/invoice.component";
import { Observable, Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { COUNTRY_CODES } from "../../data/country-codes";
import { EmployeeAssignForServiceComponent } from "../employee-assign-for-service/employee-assign-for-service.component";
import { EmployeeAssignForCustomiseComponent } from "../employee-assign-for-customise/employee-assign-for-customise.component";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { debounceTime, filter, switchMap } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { InvoiceForAdvanceComponent } from "../invoice-for-advance/invoice-for-advance.component";

@Component({
  selector: "sm-customise-booking",
  templateUrl: "./customise-booking.component.html",
  styleUrls: ["./customise-booking.component.scss"],
})
export class CustomiseBookingComponent implements OnInit, OnDestroy {
  taxSlabData: any = [];
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN
  )!;
  productsList: any = [];
  form: FormGroup;
  private _apiSubscription: Subscription = new Subscription();
  customiseBookingData: any = [];
  employeeList: any = [];
  employeeToAssign: any = [];
  toShowEmployees: boolean = false;
  public newbookingData: any = {
    price: 0,
  };

  discountInfo: any = null;
  selectedBookingType: number = 1;
  serviceList: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private fb: FormBuilder,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {
    this.form = this.fb.group({
      items: this.fb.array([]),
    });
  }
  ngOnInit(): void {
    console.log(this.parentData.data);

    let data = this.parentData.data;
    this.discountInfo = this.parentData.data.discountInfo;
    if (this.isEntityForeign == "0") {
      this._apiService.getEntityTaxSlabData(data.entityHash);
    } else if (this.isEntityForeign == "1") {
      this._apiService.getInternationalEntityTaxSlabsData(data.entityHash);
    }

    this._apiService.getServicesTypesList(data.eph, "0", "0");
    this._apiService.getEntityProductList(data.entityHash, "1");

    this._apiService.getBookingOperationDetails(data.bookingData.hash_id);

    // this._apiService.getEmployeeList(data.entityHash)

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inManageBookings:", resData);
      if (
        resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resData);

        this.serviceList = [];
        if (this.parentData.data.serviceType == "1") {
          resData.result.forEach((element: any) => {
            if (element.shopStatus == 1 && element.status == 1) {
              element.toShow = true;
              this.serviceList.push(element);
            }
          });
          // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
        } else if (this.parentData.data.serviceType == "0") {
          resData.result.forEach((element: any) => {
            if (element.homeStatus == 1 && element.status == 1) {
              element.toShow = true;
              this.serviceList.push(element);
            }
          });
          // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
        } else if (this.parentData.data.serviceType == "2") {
          resData.result.forEach((element: any) => {
            if (element.for_virtual == 1 && element.status == 1) {
              element.toShow = true;
              this.serviceList.push(element);
            }
          });
          // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
        }

        this.checkCustomiseBookingData(this.customiseBookingData).then(
          (value) => {
            console.log(value);
            // console.log("Customise booking data is available:", data);
            if (this.customiseBookingData[0].serviceInfo) {
              this.customiseBookingData[0].serviceInfo.forEach(
                (element: any) => {
                  if (element.completed_by && element.completed_by != "null") {
                    const totalQty = element.completed_by.reduce(
                      (sum: any, data: any) => sum + data.competed_services_qty,
                      0
                    );
                    element.total_completed_services_qty = totalQty;
                    this.selectServices(element);
                    this.calculateCouponDiscount();
                  }
                }
              );
            }
            console.log(this.completedJobs);
            this.loader.showLoader = false;
          }
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resData);

        this.productsList = [];
        if (resData.result) {
          if (this.parentData.data.serviceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.parentData.data.serviceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.parentData.data.serviceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }

        this.checkCustomiseBookingData(this.customiseBookingData).then(
          (value) => {
            console.log(value);
            // console.log("Customise booking data is available:", data);
            if (this.customiseBookingData[0].products) {
              this.customiseBookingData[0].products.forEach((element: any) => {
                this.selectProducts(element);
                this.calculateCouponDiscount();
              });
            }
          }
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }

      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();

          if (
            this.parentData.data.bookingData.customerPayment &&
            this.parentData.data.bookingData.customerPayment > 0
          ) {
            if (!this.isPartial) {
              this._modelRef.open(InvoiceForAdvanceComponent, {
                width: "510px",
                data: {
                  title: "Invoice",
                  showmerge: 1,
                  ref: this._modelRef,
                  data: this.parentData.data.bookingData.hash_id,
                  force: 1,
                },
              });
            } else {
              if (this.isEntityForeign == "0") {
                let bodyData = [
                  {
                    appointment_hash_id:
                      this.parentData.data.bookingData.hash_id,
                    is_primary: 1,
                    creation_date: this.formatDateString(
                      this.parentData.datetime
                        ? this.parentData.datetime
                        : new Date()
                    ),
                  },
                ];
                this._apiService.addEditEntityAdvanceInvoice(bodyData);
              } else if (this.isEntityForeign == "1") {
                let bodyData = [
                  {
                    appointment_hash_id:
                      this.parentData.data.bookingData.hash_id,
                    is_primary: 1,
                    creation_date: this.formatDateString(
                      this.parentData.datetime
                        ? this.parentData.datetime
                        : new Date()
                    ),
                  },
                ];
                this._apiService.addEditInternationalEntityAdvanceInvoice(
                  bodyData
                );
              }
            }
          } else {
            if (!this.isPartial) {
              this._modelRef.open(InvoiceComponent, {
                width: "510px",
                data: {
                  title: "Invoice",
                  showmerge: 1,
                  ref: this._modelRef,
                  data: this.parentData.data.bookingData.hash_id,
                },
              });
            }
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_BOOKING_OPERATION_DETAILS
      ) {
        this.customiseBookingData = [];
        if (resData.result) {
          if (resData.result.serviceInfo) {
            resData.result.serviceInfo = JSON.parse(resData.result.serviceInfo);
          }
          if (resData.result.coupon_info) {
            resData.result.coupon_info =
              typeof resData.result.coupon_info == "string"
                ? JSON.parse(resData.result.coupon_info)
                : resData.result.coupon_info;
          }

          if (resData.result.custom_items) {
            resData.result.custom_items = JSON.parse(
              resData.result.custom_items
            );
            resData.result.custom_items.forEach((element: any) => {
              if (element) {
                this.items.push(this.createFieldWithItem(element));
              }
              // if(element.current_status == 3){
              // }
            });
          }
          if (resData.result.products) {
            resData.result.products = JSON.parse(resData.result.products);
          }
          if (
            resData.result.coupon_discount &&
            resData.result.coupon_discount != ""
          ) {
            resData.result.coupon_discount = +resData.result.coupon_discount;
          } else if (!resData.result.coupon_discount) {
            resData.result.coupon_discount = 0;
          }

          this.customiseBookingData.push(resData.result);
          this.newbookingData.customerName =
            this.customiseBookingData[0].customer_name;
          // this.newbookingData.customerPh = (this.customiseBookingData[0].customer_phone && this.customiseBookingData[0].customer_phone != 'null' && this.customiseBookingData[0].customer_phone != '') ? this.customiseBookingData[0].customer_phone.slice(3) : ''
          this.newbookingData.customerPh =
            this.customiseBookingData[0].customer_phone;
          this.selectedCountryCode = this.countryList.find(
            (country) =>
              country.dial_code === this.customiseBookingData[0].country_code
          );
          this.newbookingData.discount = this.customiseBookingData[0].discount;
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceComponent, {
            width: "510px",
            data: {
              title: "Invoice",
              showmerge: 1,
              ref: this._modelRef,
              data: JSON.parse(resData.result).bookingHashId,
            },
          });
        }
      }
      // if(resData.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT){
      //   this.employeeList = []
      //   if(resData.result){
      //     resData.result.forEach((element:any) => {
      //      if(element.isExEmployee != 1){
      //        this.employeeList.push(element)
      //      }
      //    });
      //   }

      //  }
    });
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91"
  );
  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }

  formChecker() {
    if (this.newbookingData.customerPh) {
      if (
        this.newbookingData.customerPh.length >= 3 &&
        this.newbookingData.customerPh.length <= 17
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  /**------------all done and generate bill--------------- */

  serviceInfo: any = [];
  serviceInfoFinalise: any = [];
  completedJobs2: any = [];
  onPost() {
    if (this.completedJobs.length == 0) {
      this.snackBar.open("Add service info to continue", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.formChecker()) {
      this.snackBar.open("Enter valid phone number", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.form.invalid) {
      this.snackBar.open("Fill up all required fields of custom items", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.checkIfEmpty()) {
      this.snackBar.open("Service price cannot be empty or zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.checkIfEmptyForProduct()) {
      this.snackBar.open("Product price cannot be empty or zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (!this.newbookingData.price) {
      this.snackBar.open("Total price cannot be zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else {
      this.completedServices = [];
      this.completedJobs2 = [];
      this.productInfo = [];
      this.completedJobs.forEach((element: any) => {
        this.completedJobs2.push(element);
      });
      if (this.customiseBookingData[0].serviceInfo) {
        this.completedJobs.forEach((element: any) => {
          const totalQty = element.completed_by.reduce(
            (sum: any, data: any) => sum + data.competed_services_qty,
            0
          );
          this.completedServices.push({
            service_hash_id: element.service_type_hash,
            service_name: element.service_name,
            description: element.description,
            img_url: element.img_url,
            approxTime: element.approxTime ? element.approxTime : 60,
            completed_by_hash_ids: element.completed_by.map((data: any) => {
              return {
                completedByHashId: data.completed_by_hash,
                qty: data.competed_services_qty,
                cost: data.cost,
              };
            }),
            service_cost: element.price,
            current_status: 3,
            serviceQty: totalQty,
            service_sac_code: element.service_sac_code,
            tax_slab_hash: element.tax_slab_hash,
          });
        });
      } else {
      }

      this.productInfo = this.completedProducts.map((item: any) => {
        return {
          product_name: item.product_name,
          product_desc: item.description,
          entity_product_hash: item.entity_product_hash,
          product_img_url: item.img_url,
          product_price: item.product_price,
          product_qty: item.product_qty,
          tax_slab_hash: item.tax_slab_hash,
          hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          selling_quantity:
            Math.round(+item.qty_info * item.product_qty * 100) / 100,
          purchase_quantity:
            Math.round(
              ((+item.qty_info * item.product_qty) /
                item.selling_purchase_multiplier) *
                100
            ) / 100,
        };
      });

      let data = {
        isForeign: +this.isEntityForeign,
        appointmentHashId: this.parentData.data.bookingData.hash_id,
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        customerHashId: this.customiseBookingData[0].customer_hash,
        net_payable: this.newbookingData.price - this.newbookingData.discount,
        totalPrice: this.newbookingData.price,
        booking_current_status: 4,
        country_code: this.selectedCountryCode.dial_code,
        customerPhone: this.newbookingData.customerPh
          ? this.newbookingData.customerPh
          : "0000000000",
        discount: this.newbookingData.discount ?? 0,
        servicesInfo: this.completedServices,
        products: this.productInfo,
        custom_items: this.form.get("items")!.value.map((item: any) => {
          return {
            item_name: item.name.item_name ? item.name.item_name : item.name,
            item_desc: item.name.item_desc ?? "",
            item_inventory_hash: item.name.hash_id ?? "",
            item_img_url: item.name.image_thumb_url ?? "",
            item_qty: item.count,
            item_price: +item.price,
            tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
          };
        }),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      data.servicesInfo.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.products.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.custom_items.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      console.log(data);
      this.loader.showLoader = true;
      this._apiService.customizeBookingDetails(data);
    }
  }

  /**-------------------partially done------------------- */
  isPartial: boolean = false;
  completedServices: any = [];
  productInfo: any = [];
  partiallyDone() {
    if (this.completedJobs.length == 0) {
      this.snackBar.open("Add service info to continue", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.formChecker()) {
      this.snackBar.open("Enter valid phone number", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.form.invalid) {
      this.snackBar.open("Fill up all required fields of custom items", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.checkIfEmpty()) {
      this.snackBar.open("Service price cannot be empty or zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.checkIfEmptyForProduct()) {
      this.snackBar.open("Product price cannot be empty or zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (!this.newbookingData.price) {
      this.snackBar.open("Total price cannot be zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else {
      this.completedServices = [];
      this.isPartial = true;
      console.log(this.completedJobs);
      this.completedJobs2 = [];
      this.productInfo = [];
      // this.completedJobs.forEach((element:any) => {
      //   this.completedJobs2.push(element)
      // });
      if (this.customiseBookingData[0].serviceInfo) {
        this.completedJobs.forEach((element: any) => {
          const totalQty = element.completed_by.reduce(
            (sum: any, data: any) => sum + data.competed_services_qty,
            0
          );
          this.completedServices.push({
            service_hash_id: element.service_type_hash,
            service_name: element.service_name,
            description: element.description,
            img_url: element.img_url,
            approxTime: element.approxTime ? element.approxTime : 60,
            completed_by_hash_ids: element.completed_by.map((data: any) => {
              return {
                completedByHashId: data.completed_by_hash,
                qty: data.competed_services_qty,
                cost: data.cost,
              };
            }),
            service_cost: element.price,
            current_status: 1,
            serviceQty: totalQty,
            service_sac_code: element.service_sac_code,
            tax_slab_hash: element.tax_slab_hash,
          });
        });
      } else {
      }

      this.productInfo = this.completedProducts.map((item: any) => {
        return {
          product_name: item.product_name,
          product_desc: item.description,
          entity_product_hash: item.entity_product_hash,
          product_img_url: item.img_url,
          product_price: item.product_price,
          product_qty: item.product_qty,
          tax_slab_hash: item.tax_slab_hash,
          hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          selling_quantity:
            Math.round(+item.qty_info * item.product_qty * 100) / 100,
          purchase_quantity:
            Math.round(
              ((+item.qty_info * item.product_qty) /
                item.selling_purchase_multiplier) *
                100
            ) / 100,
        };
      });

      let data = {
        isForeign: +this.isEntityForeign,
        appointmentHashId: this.parentData.data.bookingData.hash_id,
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        customerHashId: this.customiseBookingData[0].customer_hash,
        net_payable: this.newbookingData.price - this.newbookingData.discount,
        totalPrice: this.newbookingData.price,
        booking_current_status: 3,
        country_code: this.selectedCountryCode.dial_code,
        customerPhone: this.newbookingData.customerPh
          ? this.newbookingData.customerPh
          : "0000000000",
        discount: this.newbookingData.discount ?? 0,
        servicesInfo: this.completedServices,
        products: this.productInfo,
        custom_items: this.form.get("items")!.value.map((item: any) => {
          return {
            item_name: item.name.item_name ? item.name.item_name : item.name,
            item_desc: item.name.item_desc ?? "",
            item_inventory_hash: item.name.hash_id ?? "",
            item_img_url: item.name.image_thumb_url ?? "",
            item_qty: item.count,
            item_price: +item.price,
            tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
          };
        }),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      data.servicesInfo.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.products.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.custom_items.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      console.log(data);
      this.loader.showLoader = true;
      this._apiService.customizeBookingDetails(data);
    }
  }

  allDoneAndRelease() {
    if (this.completedJobs.length == 0) {
      this.snackBar.open("Add service info to continue", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.formChecker()) {
      this.snackBar.open("Enter valid phone number", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.form.invalid) {
      this.snackBar.open("Fill up all required fields of custom items", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.checkIfEmpty()) {
      this.snackBar.open("Service price cannot be empty or zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (this.checkIfEmptyForProduct()) {
      this.snackBar.open("Product price cannot be empty or zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else if (!this.newbookingData.price) {
      this.snackBar.open("Total price cannot be zero", "Ok", {
        duration: 3000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
      });
    } else {
      this.isPartial = true;
      this.completedServices = [];
      this.completedJobs2 = [];
      this.productInfo = [];
      this.completedJobs.forEach((element: any) => {
        this.completedJobs2.push(element);
      });
      if (this.customiseBookingData[0].serviceInfo) {
        this.completedJobs.forEach((element: any) => {
          const totalQty = element.completed_by.reduce(
            (sum: any, data: any) => sum + data.competed_services_qty,
            0
          );
          this.completedServices.push({
            service_hash_id: element.service_type_hash,
            service_name: element.service_name,
            description: element.description,
            img_url: element.img_url,
            approxTime: element.approxTime ? element.approxTime : 60,
            completed_by_hash_ids: element.completed_by.map((data: any) => {
              return {
                completedByHashId: data.completed_by_hash,
                qty: data.competed_services_qty,
                cost: data.cost,
              };
            }),
            service_cost: element.price,
            current_status: 3,
            serviceQty: totalQty,
            service_sac_code: element.service_sac_code,
            tax_slab_hash: element.tax_slab_hash,
          });
        });
        // this.customiseBookingData[0].serviceInfo.forEach((element:any) => {
        //   const index = this.completedJobs2.findIndex( (x:any)=>x.service_type_hash == element.service_type_hash);
        //   console.log(index);

        //   if(index == -1){
        //     console.log(element);

        //     let data = {
        //       service_type_hash: element.service_type_hash,
        //       service_name: element.service_name,
        //       price: element.price,
        //       note: element.note,
        //       img_url: element.img_url,
        //       employee_name: element.employee_name,
        //       employee_hash_id: element.employee_hash_id,
        //       description: element.description,
        //       current_status: 3,
        //       isDelete: 1
        //     }

        //     this.completedJobs2.push(data)
        //   }
        // });
      } else {
      }

      this.productInfo = this.completedProducts.map((item: any) => {
        return {
          product_name: item.product_name,
          product_desc: item.description,
          entity_product_hash: item.entity_product_hash,
          product_img_url: item.img_url,
          product_price: item.product_price,
          product_qty: item.product_qty,
          tax_slab_hash: item.tax_slab_hash,
          hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          created_by_hash: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID
          ),
          selling_quantity:
            Math.round(+item.qty_info * item.product_qty * 100) / 100,
          purchase_quantity:
            Math.round(
              ((+item.qty_info * item.product_qty) /
                item.selling_purchase_multiplier) *
                100
            ) / 100,
        };
      });

      let data = {
        isForeign: +this.isEntityForeign,
        appointmentHashId: this.parentData.data.bookingData.hash_id,
        customerName: this.newbookingData.customerName
          ? this.newbookingData.customerName
          : "New Customer",
        customerHashId: this.customiseBookingData[0].customer_hash,
        net_payable: this.newbookingData.price - this.newbookingData.discount,
        totalPrice: this.newbookingData.price,
        booking_current_status: 4,
        country_code: this.selectedCountryCode.dial_code,
        customerPhone: this.newbookingData.customerPh
          ? this.newbookingData.customerPh
          : "0000000000",
        discount: this.newbookingData.discount ?? 0,
        servicesInfo: this.completedServices,
        products: this.productInfo,
        custom_items: this.form.get("items")!.value.map((item: any) => {
          return {
            item_name: item.name.item_name ? item.name.item_name : item.name,
            item_desc: item.name.item_desc ?? "",
            item_inventory_hash: item.name.hash_id ?? "",
            item_img_url: item.name.image_thumb_url ?? "",
            item_qty: item.count,
            item_price: +item.price,
            tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
          };
        }),
      };

      Object.keys(data).forEach((key) => {
        if ((data as any)[key] === null) {
          delete (data as any)[key];
        }
      });
      data.servicesInfo.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.products.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      data.custom_items.forEach((element: any) => {
        Object.keys(element).forEach((key) => {
          if ((element as any)[key] === null) {
            delete (element as any)[key];
          }
        });
      });
      console.log(data);
      this.loader.showLoader = true;
      this._apiService.customizeBookingDetails(data);
    }
  }
  changeChip(value: number) {
    this.selectedBookingType = value;
    // this.loader = true
    // this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
  }
  completedJobs: any = [];
  selectServices(item: any) {
    console.log(item);
    if (item.service_type_hash) {
      // being added from api list
      console.log(item);

      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash
      );
      console.log(index);

      if (index != -1) {
        this.completedJobs.push(item);
        this.newbookingData.price += item.price;

        this.serviceList[index].toShow = false;
      }

      // this.serviceList[index].current_status = 3
    } else if (item.hash_id) {
      // being added from my list
      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // this.completedJobs.push(this.serviceList[index])
      console.log(this.serviceList[index]);

      let data = {
        service_type_hash: item.hash_id,
        service_name: item.serviceName,
        price:
          this.parentData.data.serviceType == "0"
            ? item.discountStatus == 1
              ? item.homeDiscountedPrice
              : item.home_rate
            : this.parentData.data.serviceType == "1"
            ? item.discountStatus == 1
              ? item.shopDiscountedPrice
              : item.shop_rate
            : item.discountStatus == 1
            ? item.virtual_discounted_amount
            : item.virtual_rate,
        note: item.note,
        img_url: item.imgUrl,
        completed_by: [
          {
            cost:
              this.parentData.data.serviceType == "0"
                ? item.discountStatus == 1
                  ? item.homeDiscountedPrice
                  : item.home_rate
                : this.parentData.data.serviceType == "1"
                ? item.discountStatus == 1
                  ? item.shopDiscountedPrice
                  : item.shop_rate
                : item.discountStatus == 1
                ? item.virtual_discounted_amount
                : item.virtual_rate,
            employee_name:
              localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + "(Owner)",
            completed_by_hash: localStorage.getItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
            ),
            competed_services_qty: 1,
          },
        ],
        description: item.description,
        current_status: 3,
        total_completed_services_qty: 1,
      };

      this.completedJobs.push(data);
      this.newbookingData.price += data.price;
      this.serviceList[index].toShow = false;
    }

    console.log("completedJobs:::", this.completedJobs);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  completedProducts: any = [];
  selectProducts(item: any) {
    console.log(item);
    if (item.entity_product_hash) {
      // being added from api list
      console.log(item);

      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.entity_product_hash
      );
      console.log(index);

      if (index != -1) {
        let data = {
          entity_product_hash: item.entity_product_hash,
          product_name: item.prouct_name,
          product_price: item.item_price,
          img_url: item.product_img_url,
          description: item.product_description,
          current_status: 3,
          product_qty: item.product_qty,
          tax_slab_hash: item.tax_slab_hash,
          product_hsn_code: item.product_hsn_code,
          inventory_item_hash: item.inventory_item_hash,
          purchase_unit: item.purchase_unit,
          selling_unit: item.selling_unit,
          selling_purchase_multiplier: item.selling_purchase_multiplier,
          qty_info: this.productsList[index].qty_info,
        };

        this.completedProducts.push(data);
        this.newbookingData.price += data.product_price;
        this.productsList[index].toShow = false;
      }

      // this.serviceList[index].current_status = 3
    } else if (item.hash_id) {
      // being added from my list
      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id
      );
      // this.completedJobs.push(this.serviceList[index])
      console.log(this.productsList[index]);

      let data = {
        entity_product_hash: item.hash_id,
        product_name: item.product_name,
        product_price:
          this.parentData.data.serviceType == "0"
            ? item.discount_status == 1
              ? item.home_discounted_price
              : item.home_price
            : this.parentData.data.serviceType == "1"
            ? item.discount_status == 1
              ? item.shop_discounted_price
              : item.shop_price
            : item.discount_status == 1
            ? item.virtual_discounted_price
            : item.virtual_price,
        img_url: item.thumb_image_url,
        description: item.product_desc,
        current_status: 3,
        product_qty: 1,
        tax_slab_hash: item.tax_slab_hash,
        product_hsn_code: item.product_hsn_code,
        inventory_item_hash: item.inventory_item_hash,
        purchase_unit: item.purchase_unit,
        selling_unit: item.selling_unit,
        selling_purchase_multiplier: item.selling_purchase_multiplier,
        qty_info: item.qty_info,
      };

      this.completedProducts.push(data);
      this.newbookingData.price += data.product_price;
      this.productsList[index].toShow = false;
    }

    console.log("completedProduct:::", this.completedProducts);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  changeServicePrice(item: any) {
    console.log(item.price);
    this.newbookingData.price = 0;
    this.completedJobs.forEach((element: any) => {
      this.newbookingData.price += element.price;
    });
    console.log(this.newbookingData.price);
    this.completedProducts.forEach((element: any) => {
      this.newbookingData.price += element.product_price;
    });
    console.log(this.newbookingData.price);
    this.form.get("items")!.value.forEach((element: any) => {
      this.newbookingData.price += +element.price;
    });

    this.checkIfEmpty();
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  changeProductPrice(item: any) {
    console.log(item.price);
    this.newbookingData.price = 0;
    this.completedJobs.forEach((element: any) => {
      this.newbookingData.price += element.price;
    });
    this.completedProducts.forEach((element: any) => {
      this.newbookingData.price += element.product_price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.newbookingData.price += +element.price;
    });

    this.checkIfEmptyForProduct();
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  selectEmployeeToAssign(item: any) {
    this.employeeToAssign = [];
    this.employeeList.forEach((element: any) => {
      element.selected = false;
    });
    item.selected = true;

    this.employeeToAssign.push(item);

    // this.selectedTopicHashId = item.hash_id
    // this.selectedTopicName = item.topic_name
  }

  assignEmployee(item: any, index: any) {
    console.log(item);

    let dialogref = this._modelRef.open(EmployeeAssignForCustomiseComponent, {
      width: "600px",
      disableClose: true,
      data: {
        data: item,
        serviceType: this.parentData.data.serviceType,
      },
    });

    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);

        this.completedJobs[index] = res;
        console.log(this.completedJobs);
        if (!res.completed_by || res.completed_by.length == 0) {
          const index1 = this.serviceList.findIndex(
            (x: any) => x.hash_id == item.service_type_hash
          );
          this.serviceList[index1].toShow = true;
          this.completedJobs.splice(index, 1);
        }
        this.newbookingData.price = 0;
        this.completedJobs.forEach((element: any) => {
          element.completed_by.forEach((item: any) => {
            this.newbookingData.price += item.cost;
          });
        });
        this.completedProducts.forEach((element: any) => {
          this.newbookingData.price += element.product_price;
        });
        this.form.get("items")!.value.forEach((element: any) => {
          this.newbookingData.price += +element.price;
        });
        this.calculateDiscount();
        this.calculateCouponDiscount();
      }
    });
    // this.toAssignEmployeeService.employee_name = this.employeeToAssign[0].name
    // this.toAssignEmployeeService.employee_hash_id = this.employeeToAssign[0].employeeHashId
    // this.toShowEmployees = false
    // this.employeeToAssign = []
    // this.employeeList.forEach((element:any) => {
    //   element.selected = false
    // });
  }
  removeCompletedJobs(item: any) {
    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.service_type_hash
    );
    const index1 = this.completedJobs.findIndex(
      (x: any) => x.service_type_hash == item.service_type_hash
    );

    this.newbookingData.price -= this.completedJobs[index1].price;
    this.serviceList[index].toShow = true;
    this.completedJobs.splice(index1, 1);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  removeCompletedProducts(item: any) {
    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.entity_product_hash
    );
    const index1 = this.completedProducts.findIndex(
      (x: any) => x.entity_product_hash == item.entity_product_hash
    );

    this.newbookingData.price -= this.completedProducts[index1].product_price;
    this.productsList[index].toShow = true;
    this.completedProducts.splice(index1, 1);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  toAssignEmployeeService: any;
  showEmployee(item: any) {
    this.toAssignEmployeeService = item;
    this.toShowEmployees = !this.toShowEmployees;
  }
  hideEmployee() {
    this.toShowEmployees = !this.toShowEmployees;
  }
  decreaseServiceCount(item: any, index: any) {
    if (this.completedJobs[index].total_completed_services_qty == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash
      );
      // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      // if(this.parentData.data.serviceType == '0'){
      //   if(this.completedJobs[index].discountStatus == 1){
      //     this.newbookingData.price -= this.completedJobs[index].homeDiscountedPrice
      //   }
      //   else if(this.completedJobs[index].discountStatus == 0){
      //     this.newbookingData.price -= this.completedJobs[index].home_rate
      //   }
      // }
      // else if(this.parentData.data.serviceType == '1'){
      //   if(this.completedJobs[index].discountStatus == 1){
      //     this.newbookingData.price -= this.completedJobs[index].shopDiscountedPrice
      //   }
      //   else if(this.completedJobs[index].discountStatus == 0){
      //     this.newbookingData.price -= this.completedJobs[index].shop_rate
      //   }
      // }
      this.newbookingData.price -=
        this.completedJobs[index].price /
        this.completedJobs[index].total_completed_services_qty;
      this.serviceList[index1].toShow = true;
      this.completedJobs.splice(index, 1);
    } else {
      const index1 = item.completed_by.findIndex(
        (x: any) =>
          x.completed_by_hash ==
          localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)
      );
      console.log(index1);

      // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
      // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      // let service_cost
      // if(this.parentData.data.serviceType == '0'){
      //   if(this.completedJobs[index].discountStatus == 1){
      //     service_cost = this.completedJobs[index].homeDiscountedPrice
      //     // this.newbookingData.price += this.completedJobs[index].homeDiscountedPrice
      //   }
      //   else if(this.completedJobs[index].discountStatus == 0){
      //     service_cost = this.completedJobs[index].home_rate
      //     // this.newbookingData.price += this.completedJobs[index].home_rate
      //   }
      // }
      // else if(this.parentData.data.serviceType == '1'){
      //   if(this.completedJobs[index].discountStatus == 1){
      //     service_cost = this.completedJobs[index].shopDiscountedPrice
      //     // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
      //   }
      //   else if(this.completedJobs[index].discountStatus == 0){
      //     service_cost = this.completedJobs[index].shop_rate
      //     // this.newbookingData.price += this.completedJobs[index].shop_rate
      //   }
      // }

      this.newbookingData.price -=
        this.completedJobs[index].price /
        this.completedJobs[index].total_completed_services_qty;
      if (index1 == -1) {
        if (
          item.completed_by[item.completed_by.length - 1]
            .competed_services_qty == 1
        ) {
          item.completed_by.splice(item.completed_by.length - 1, 1);
        } else {
          item.completed_by[item.completed_by.length - 1]
            .competed_services_qty--;
          item.completed_by[item.completed_by.length - 1].cost -=
            this.completedJobs[index].price /
            this.completedJobs[index].total_completed_services_qty;
        }
        // item.completed_by.splice(item.completed_by.length-1,1)
      } else {
        if (item.completed_by[index1].competed_services_qty == 1) {
          item.completed_by.splice(index1, 1);
        } else {
          item.completed_by[index1].cost -=
            this.completedJobs[index].price /
            this.completedJobs[index].total_completed_services_qty;
          item.completed_by[index1].competed_services_qty -= 1;
        }
      }

      this.completedJobs[index].price -=
        this.completedJobs[index].price /
        this.completedJobs[index].total_completed_services_qty;
      this.completedJobs[index].total_completed_services_qty--;
    }
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  increaseServiceCount(item: any, index: any) {
    this.newbookingData.price += item.price / item.total_completed_services_qty;

    const index1 = item.completed_by.findIndex(
      (x: any) =>
        x.completed_by_hash ==
        localStorage.getItem(SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID)
    );
    console.log(index1);

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.completedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    // let service_cost
    // if(this.parentData.data.serviceType == '0'){
    //   if(this.completedJobs[index].discountStatus == 1){
    //     service_cost = this.completedJobs[index].homeDiscountedPrice
    //     // this.newbookingData.price += this.completedJobs[index].homeDiscountedPrice
    //   }
    //   else if(this.completedJobs[index].discountStatus == 0){
    //     service_cost = this.completedJobs[index].home_rate
    //     // this.newbookingData.price += this.completedJobs[index].home_rate
    //   }
    // }
    // else if(this.parentData.data.serviceType == '1'){
    //   if(this.completedJobs[index].discountStatus == 1){
    //     service_cost = this.completedJobs[index].shopDiscountedPrice
    //     // this.newbookingData.price += this.completedJobs[index].shopDiscountedPrice
    //   }
    //   else if(this.completedJobs[index].discountStatus == 0){
    //     service_cost = this.completedJobs[index].shop_rate
    //     // this.newbookingData.price += this.completedJobs[index].shop_rate
    //   }
    // }

    if (index1 == -1) {
      item.completed_by.push({
        cost: item.price,
        employee_name:
          localStorage.getItem(SM_CONSTANTS.OWNER_NAME) + "(Owner)",
        completed_by_hash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        competed_services_qty: 1,
      });
    } else {
      item.completed_by[index1].cost +=
        item.price / item.total_completed_services_qty;
      item.completed_by[index1].competed_services_qty += 1;
    }
    item.price += item.price / item.total_completed_services_qty;
    item.total_completed_services_qty++;
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  decreaseProductCount(item: any, index: any) {
    if (this.completedProducts[index].product_qty == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.entity_product_hash
      );

      this.newbookingData.price -=
        this.completedProducts[index].product_price /
        this.completedProducts[index].product_qty;
      this.productsList[index1].toShow = true;
      this.completedProducts.splice(index, 1);
    } else {
      this.newbookingData.price -=
        this.completedProducts[index].product_price /
        this.completedProducts[index].product_qty;
      this.completedProducts[index].product_price -=
        this.completedProducts[index].product_price /
        this.completedProducts[index].product_qty;
      this.completedProducts[index].product_qty--;
    }
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  increaseProductCount(item: any, index: any) {
    this.newbookingData.price += item.product_price / item.product_qty;

    item.product_price += item.product_price / item.product_qty;
    item.product_qty++;
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }
  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  checkCustomiseBookingData(customiseBookingData: any): Promise<any> {
    console.log("hitting");

    return new Promise((resolve) => {
      const intervalId = setInterval(() => {
        // console.log("hitting");
        console.log(this.customiseBookingData);

        if (this.customiseBookingData && this.customiseBookingData.length > 0) {
          clearInterval(intervalId);
          resolve(this.customiseBookingData);
        }
      }, 100); // interval time (adjust as needed)
    });
  }
  emptyCheck: boolean = false;
  checkIfEmpty(): boolean {
    if (this.completedJobs.length > 0) {
      for (const element of this.completedJobs) {
        if (!element.price || element.price === "" || element.price == null) {
          return true;
        }
      }
      return false; // all have price
    } else {
      return false;
    }
  }
  emptyCheckForProduct: boolean = false;
  checkIfEmptyForProduct(): boolean {
    for (const element of this.completedProducts) {
      if (
        !element.product_price ||
        element.product_price === "" ||
        element.product_price == null
      ) {
        return true;
      }
    }
    return false;
  }

  addOneHourAndFormat(date: Date): string {
    const newDate = new Date(date);
    newDate.setHours(date.getHours() + 1);

    const hours = newDate.getHours().toString().padStart(2, "0");
    const minutes = newDate.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  discountCalculated: boolean = false;
  calculateDiscount() {
    if (
      !this.customiseBookingData[0].discount ||
      this.customiseBookingData[0].discount == 0 ||
      this.newbookingData.discount == 0 ||
      !this.newbookingData.discount ||
      this.newbookingData.discount == "" ||
      this.discountCalculated
    ) {
      this.discountCalculated = true;
      this.newbookingData.discount = 0;

      if (this.discountInfo.discountStatus == 1) {
        if (
          this.isCurrentDateInRange(
            this.discountInfo.start_date,
            this.discountInfo.end_date
          )
        ) {
          // percentage discount
          if (this.discountInfo.discountType == 1) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount =
                      this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount =
                      this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  let cal_disc =
                    (+this.discountInfo.discountAmount / 100) *
                    +this.newbookingData.price;
                  console.log(cal_disc);

                  if (cal_disc >= this.discountInfo.maxDiscount) {
                    this.newbookingData.discount =
                      this.discountInfo.maxDiscount;
                  } else {
                    this.newbookingData.discount = cal_disc;
                  }
                }
              }
            }
          }
          // amount discount
          else if (this.discountInfo.discountType == 2) {
            if (this.newbookingData.price >= this.discountInfo.minBillAmount) {
              // home service
              if (this.parentData.data.serviceType == "0") {
                if (this.discountInfo.home_service_status == 1) {
                  this.newbookingData.discount =
                    this.discountInfo.discountAmount;
                }
              }
              // shop service
              else if (this.parentData.data.serviceType == "1") {
                if (this.discountInfo.shop_service_status == 1) {
                  this.newbookingData.discount =
                    this.discountInfo.discountAmount;
                }
              }
              // virtual service
              else if (this.parentData.data.serviceType == "2") {
                if (this.discountInfo.virtual_service_status == 1) {
                  this.newbookingData.discount =
                    this.discountInfo.discountAmount;
                }
              }
            }
          }
        }
      }

      this.newbookingData.discount = +this.newbookingData.discount.toFixed(2);
    }
  }

  isCurrentDateInRange(start_date: string, end_date: string): boolean {
    const currentDate = new Date();
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);

    // Normalize the dates by setting the time to 00:00:00
    const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const normalizedCurrentDate = normalizeDate(currentDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    // Check if the current date is between start and end date (inclusive)
    return (
      normalizedCurrentDate >= normalizedStartDate &&
      normalizedCurrentDate <= normalizedEndDate
    );
  }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): FormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as FormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }

      this.calculateDiscount();
      this.calculateCouponDiscount();
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }

  createFieldWithItem(item: any): FormGroup {
    const itemGroup = this.fb.group({
      name: [
        {
          item_name: item.item_name,
          item_desc: item.item_description,
          hash_id: item.inventory_item_hash,
          image_thumb_url: null,
        },
        Validators.required,
      ],
      price: [item.item_price, Validators.required],
      count: [item.item_qty, Validators.required],
      tax_slab: [item.tax_slab_hash ? item.tax_slab_hash : "default"],
    });

    const filterControl = itemGroup.get("name") as FormControl;

    // Listen for changes, trigger API call if length > 2
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300),
    //   filter((value) => value && typeof value === "string" && value.length > 2),
    //   switchMap((value) => this.fetchOptions(value))
    // );
    // this.filteredOptions.push(filteredOption);

    const priceControl = itemGroup.get("price") as FormControl;
    let previousPrice = item.item_price; // ✅ Set to initial price

    // Add initial price to total once
    this.newbookingData.price += item.item_price;

    priceControl.valueChanges.subscribe((value) => {
      const parsedValue = Number(value);
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        this.newbookingData.price =
          this.newbookingData.price - previousPrice + parsedValue;
        previousPrice = parsedValue;
      }
      this.calculateDiscount();
      this.calculateCouponDiscount();
    });

    return itemGroup;
  }

  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentData.data.entityHash}&searchKey=${value}&pageNo=1&count=25`
    );
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  // Get the form array of items
  get items(): FormArray {
    return this.form.get("items") as FormArray;
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.newbookingData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
    this.calculateDiscount();
    this.calculateCouponDiscount();
  }

  changedDiscountByBusiness(event: any) {
    console.log(event);
    this.discountCalculated = false;
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      // this.newbookingData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    this.newbookingData = {
      price: 0,
    };
  }

  calculateCouponDiscount() {
    if (this.customiseBookingData[0].coupon_code) {
      this.customiseBookingData[0].coupon_discount = 0;
      console.log("inside coupon");

      // percentage discount
      if (this.customiseBookingData[0].coupon_info.discount_type == 1) {
        if (
          this.newbookingData.price >=
          this.customiseBookingData[0].coupon_info.minimum_cart_value
        ) {
          let cal_disc =
            (+this.customiseBookingData[0].coupon_info.discount_value / 100) *
            +this.newbookingData.price;
          if (
            cal_disc >= this.customiseBookingData[0].coupon_info.max_discount
          ) {
            this.customiseBookingData[0].coupon_discount =
              this.customiseBookingData[0].coupon_info.max_discount;
          } else {
            this.customiseBookingData[0].coupon_discount = cal_disc;
          }
          // // home service
          // if (this.parentData.data.serviceType == "0") {
          //   if (this.discountInfo.home_service_status == 1) {
          //   }
          // }
          // // shop service
          // else if (this.parentData.data.serviceType == "1") {
          //   if (this.discountInfo.shop_service_status == 1) {
          //     let cal_disc =
          //       (+this.discountInfo.discountAmount / 100) *
          //       +this.newbookingData.price;
          //     console.log(cal_disc);

          //     if (cal_disc >= this.discountInfo.maxDiscount) {
          //       this.newbookingData.discount = this.discountInfo.maxDiscount;
          //     } else {
          //       this.newbookingData.discount = cal_disc;
          //     }
          //   }
          // }
          // // virtual service
          // else if (this.parentData.data.serviceType == "2") {
          //   if (this.discountInfo.virtual_service_status == 1) {
          //     let cal_disc =
          //       (+this.discountInfo.discountAmount / 100) *
          //       +this.newbookingData.price;
          //     console.log(cal_disc);

          //     if (cal_disc >= this.discountInfo.maxDiscount) {
          //       this.newbookingData.discount = this.discountInfo.maxDiscount;
          //     } else {
          //       this.newbookingData.discount = cal_disc;
          //     }
          //   }
          // }
        }
      }
      // amount discount
      else if (this.customiseBookingData[0].coupon_info.discount_type == 2) {
        if (
          this.newbookingData.price >=
          this.customiseBookingData[0].coupon_info.minimum_cart_value
        ) {
          this.customiseBookingData[0].coupon_discount =
            this.customiseBookingData[0].coupon_info.discount_value;

          // // home service
          // if (this.parentData.data.serviceType == "0") {
          //   if (this.discountInfo.home_service_status == 1) {
          //   }
          // }
          // // shop service
          // else if (this.parentData.data.serviceType == "1") {
          //   if (this.discountInfo.shop_service_status == 1) {
          //     this.newbookingData.discount = this.discountInfo.discountAmount;
          //   }
          // }
          // // virtual service
          // else if (this.parentData.data.serviceType == "2") {
          //   if (this.discountInfo.virtual_service_status == 1) {
          //     this.newbookingData.discount = this.discountInfo.discountAmount;
          //   }
          // }
        }
      }

      // this.newbookingData.discount = +this.newbookingData.discount.toFixed(2);
    }
  }
}
